<div class="body loginCard">
    <div class="container mt-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="card shadow-sm">
                    <div class="card-header text-white text-center">
                        <h3 class="roboTitle title">Registrazione Utente</h3>
                    </div>
                    <div class="card-body" style="background-color: #EFEEE7;">
                        <div class="form-section">
                            <h4 style="font-weight: bold;">Dati Anagrafici</h4>
                            <div class="mb-3">
                                <label for="email" class="form-label">Email</label>
                                <input type="text" class="form-control" id="email" [(ngModel)]="utente.email">
                            </div>
                            <div class="mb-3">
                                <label for="ragioneSociale" class="form-label">Nome e cognome o ragione sociale (se azienda)</label>
                                <input type="text" class="form-control" id="ragioneSociale" [(ngModel)]="utente.denominazione">
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label for="codiceFiscale" class="form-label">Codice Fiscale</label>
                                    <input type="text" class="form-control" id="codiceFiscale" [(ngModel)]="utente.codice_fiscale">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="partitaIva" class="form-label">Partita IVA (Controllo automatico con il VIES)</label>
                                    <input type="text" class="form-control" id="partitaIva" (change)="controllaPiva($event)" [(ngModel)]="utente.partita_iva">
                                </div>
                            </div>
                        </div>
                        
                        <hr>

                        <div class="form-section">
                            <h4 style="font-weight: bold;">Sede della società</h4>
                            <div class="row">
                                <div class="col-md-8 mb-3">
                                    <label for="indirizzo" class="form-label">Indirizzo *</label>
                                    <input type="text" class="form-control" id="indirizzo" [(ngModel)]="utente.indirizzo">
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="cap" class="form-label">CAP *</label>
                                    <input type="text" class="form-control" id="cap" pattern="^[0-9]{5}$" [(ngModel)]="utente.cap">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 mb-3">
                                    <label for="citta" class="form-label">Città *</label>
                                    <input type="text" class="form-control" id="citta" [(ngModel)]="utente.comune">
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="provincia" class="form-label">Provincia *</label>
                                    <input type="text" class="form-control" id="provincia" pattern="^[A-Za-z]{2}$" [(ngModel)]="utente.provincia">
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="nazione" class="form-label">Nazione *</label>
                                    <input type="text" class="form-control" id="nazione" pattern="^[A-Za-z]{2}$" [(ngModel)]="utente.nazione">
                                </div>
                            </div>
                        </div>

                        <div class="mb-3 form-check">
                            <input type="checkbox" class="form-check-input" id="terminiCondizioni" [(ngModel)]="condizioni">
                            <label class="form-check-label" for="terminiCondizioni">Accetto i termini e le condizioni *</label>
                        </div>
                        
                        <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-primary btnLogin" (click)="registrazione()">Registrati</button>
                            <button type="button" class="btn btn-secondary btn-lg" (click)="index()">Indietro</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-toast #toast></app-toast>